import useSWR from "swr";
import { useContext } from "react";
import { Constants } from "@CONFIG";
import { axios } from "@LIBS";
import { useHistory } from "react-router";
import { AuthContext } from "@CONTEXTS";

const doLogin = async ({ email, password }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/login`,
    method: "POST",
    data: { email, password },
    hideSuccessMessage: true,
  });
  if (response?.notVerified) {
    localStorage.setItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY, response.token);
    return response;
  }
  if (response?.data?.verificationTypes) {
    localStorage.setItem(
      Constants.LOCAL_STORAGE_PRE_AUTH_KEY,
      response.data?.token
    );
    return response?.data;
  }
  if (response?.lockAccount) {
    return "blockedPassword";
  }
  if (response?.blockedAccount) {
    return "blockedAccount";
  }
  if (response?.token) {
    localStorage.setItem(Constants.LOCAL_STORAGE_AUTH_KEY, response.token);
    return response.token;
  }

  return null;
};

const doLogout = async () => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/logout`,
    method: "POST",
  });

  return response;
};

const useMe = (token) => {
  const { logOut } = useContext(AuthContext);
  const history = useHistory();
  return useSWR(
    token ? `${Constants.BACKEND_API_URL}/api/auth/me` : null,
    (url) =>
      axios({
        url,
        method: "GET",
        redirectIfFailed: () => {
          logOut();
          history.push("/auth/login");
        },
        hideErrorMessageFromServer: true,
      })
  );
};

const doForgotPassword = async ({ email }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/forgotPassword`,
    method: "POST",
    data: { email },
  });
  if (response?.success && response?.data?.token) {
    localStorage.setItem(
      Constants.LOCAL_STORAGE_PRE_AUTH_KEY,
      response.data?.token
    );

    return response.data;
  }
  return null;
};

const doVerifyOtp = async ({ verificationId, verificationCode }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/verifyOtp`,
    method: "POST",
    data: { verificationId, verificationCode },
  });
  if (response?.token) {
    localStorage.setItem(Constants.LOCAL_STORAGE_AUTH_KEY, response.token);
    return response.token;
  }
  if (response?.blocked) {
    return "BLOCKEDOTP";
  }
  return null;
};

const doResendOtp = async ({ verificationId, phone }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/reSendOtp`,
    method: "POST",
    data: { verificationId, phone },
  });
  if (response?.success) {
    return response.data;
  }
  return null;
};
const doSendOtp = async ({ id, verificationType }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/sendOtp`,
    method: "POST",
    data: { id, verificationType },
    hideSuccessMessage: true,
  });
  if (response?.success) {
    return response.data;
  }
  return null;
};

const doSendVerifyType = async ({ email, verifyType, phone }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/sendVerifyType`,
    method: "POST",
    data: { email, verifyType, phone },
  });
  if (response?.success) {
    return response.data;
  }
  return null;
};
const doVerifyType = async ({ verificationId, verificationCode, phone }) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/setVerifyType`,
    method: "POST",
    data: { verificationId, verificationCode, phone },
  });
  if (response?.success) {
    return { success: true, token: response?.token };
  }
  return null;
};

export {
  useMe,
  doLogin,
  doLogout,
  doForgotPassword,
  doVerifyOtp,
  doResendOtp,
  doSendVerifyType,
  doVerifyType,
  doSendOtp,
};
